try {
    window.$ = window.jQuery = require("jquery");
    require("bootstrap-sass");
} catch (e) {}
require("slick-carousel");
window.Vue = require("vue");
Vue.use(require("vue-resource"));
window.validator = require("jquery-validation");
window.validate = require("./validate");
window.toastr = require("toastr");
window.Ladda = require("ladda");
require("spin.js");
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

Vue.http.headers.common["X-CSRF-TOKEN"] = $('meta[name="csrf-token"]').attr(
    "content"
);
// Refer & Earn
new Vue({
    name: "TqReferEarn",
    el: "#traqade-refer",
    data() {
        return {
            request: {
                utm_source: utmSource,
                utm_medium: utmMedium,
                utm_campaign: utmCampaign,
                requestSource: requestSource,
                requestType: "TraqadeFreeTrial",
                name: "",
                email: "",
                mobile: "",
                op_city: "",
                op_gym: "",
                op_message: "",
                op_referer_name: "",
                op_referer_email: "",
                op_referer_mobile: "",
            },
        };
    },
    mounted: function() {
        $("#refer-slideshow")
            .not(".slick-initialized")
            .slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: "linear",
                centerMode: true,
                arrows: false,
            });
    },
    methods: {
        createUserRequest: function() {
            var isValid = validate.formIsValid("referEarnForm");
            var reqLoader = Ladda.create(
                document.querySelector(".traqadeSubmitBtnLoader")
            );
            if (!isValid) {
                return false;
            }
            reqLoader.start();

            this.$http
                .post("/api/traqade/request", this.request)
                .then((response) => {
                    console.log(response);
                    if (response.body.hasError) {
                        toastr["error"](response.body.error);
                        return false;
                    }
                    // toastr["success"](response.body.message);
                    this.request = {
                        utm_source: utmSource,
                        utm_medium: utmMedium,
                        utm_campaign: utmCampaign,
                        requestSource: requestSource,
                        requestType: "TraqadeFreeTrial",
                        name: "",
                        email: "",
                        mobile: "",
                        op_city: "",
                        op_gym: "",
                        op_message: "",
                        op_referer_name: "",
                        op_referer_email: "",
                        op_referer_mobile: "",
                    };
                    reqLoader.stop();
                    reqLoader.remove();
                    $("#request-success").modal("show");
                    $("#traqade-refer").modal("hide");
                });
        },
    },
});
